import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';

type Props = {
  remark_edit: string | null | undefined;
  remark_edit_review?: string | null | undefined;
  remark_approval: string | null | undefined;
};

export function QuotationFormCatatanQuotationTabScreen({
  remark_edit,
  remark_edit_review,
  remark_approval,
}: Props) {
  const editTrim = (remark_edit ?? '').trim();
  const editReviewTrim = (remark_edit_review ?? '').trim();
  const approvalTrim = (remark_approval ?? '').trim();

  return (
    <Stack spacing={2} sx={{ maxWidth: 720 }}>
      <Typography variant="body2" color="text.secondary">
        Catatan ini berasal dari proses workflow (mis. saat minta revisi / persetujuan).
      </Typography>

      {editTrim ? (
        <TextField
          label="Catatan revisi (PIC)"
          value={editTrim}
          multiline
          minRows={3}
          fullWidth
          InputProps={{ readOnly: true }}
          inputProps={{ 'data-testid': 'quotation-notes-remark-edit' }}
        />
      ) : null}

      {editReviewTrim ? (
        <TextField
          label="Catatan review revisi (SPV)"
          value={editReviewTrim}
          multiline
          minRows={3}
          fullWidth
          InputProps={{ readOnly: true }}
          inputProps={{ 'data-testid': 'quotation-notes-remark-edit-review' }}
        />
      ) : null}

      {approvalTrim ? (
        <TextField
          label="Catatan persetujuan"
          value={approvalTrim}
          multiline
          minRows={3}
          fullWidth
          InputProps={{ readOnly: true }}
          inputProps={{ 'data-testid': 'quotation-notes-remark-approval' }}
        />
      ) : null}

      {!editTrim && !editReviewTrim && !approvalTrim ? (
        <Typography variant="body2" color="text.secondary" data-testid="quotation-notes-empty">
          Tidak ada catatan.
        </Typography>
      ) : null}
    </Stack>
  );
}
